(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7845],{

/***/ 80693:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[[...doc]]",
      function () {
        return __webpack_require__(18197);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ HighlightCodeBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Docs/Docs.module.scss
var Docs_module = __webpack_require__(75698);
var Docs_module_default = /*#__PURE__*/__webpack_require__.n(Docs_module);
// EXTERNAL MODULE: ./node_modules/react-code-blocks/dist/react-code-blocks.esm.js + 13 modules
var react_code_blocks_esm = __webpack_require__(41443);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/CodeBlock/highlight-code-theme.ts
var highlight_code_theme = __webpack_require__(10198);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/document-duplicate.svg
/* harmony default export */ var document_duplicate = ({"src":"/_next/static/media/document-duplicate.070abf52.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/checkmark_circle.svg
/* harmony default export */ var checkmark_circle = ({"src":"/_next/static/media/checkmark_circle.ba3ad5e6.svg","height":16,"width":16});
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 2 modules
var listbox = __webpack_require__(79949);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(46032);
;// CONCATENATED MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx












const HighlightCodeBlock = (props)=>{
    const [copied, setCopied] = (0,react.useState)(false);
    const [selected, setSelected] = (0,react.useState)(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Docs_module_default()).codeBlock,
        style: props.style,
        children: [
            props.topbar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).codeBlockTopper,
                children: props.product.types && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-28 ml-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
                        value: selected,
                        onChange: setSelected,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                                    className: "relative w-full cursor-pointer rounded-lg bg-dark-background py-2 my-[10px] pl-3 pr-4 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy4",
                                            emphasis: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block truncate",
                                                children: props.product.types[selected]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpDownIcon/* default */.Z, {
                                                className: "h-5 w-5 text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                    as: react.Fragment,
                                    leave: "transition ease-in duration-100",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                        className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md border-2 border-divider-on-dark bg-color-primary-500 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                        children: props.product.types.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                                className: (param)=>{
                                                    let { active  } = param;
                                                    return "relative cursor-pointer select-none mx-1 py-1 pl-2 pr-4 rounded-md ".concat(active ? "bg-divider-on-dark text-white" : "text-copy-on-dark");
                                                },
                                                value: index,
                                                children: (param)=>/*#__PURE__*/ {
                                                    let { selected  } = param;
                                                    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                                type: "copy4",
                                                                emphasis: true,
                                                                children: type
                                                            })
                                                        })
                                                    });
                                                }
                                            }, index))
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_code_blocks_esm/* CodeBlock */.dn, {
                language: props.language,
                text: props.text || props.product.snippets[selected] || "",
                showLineNumbers: props.showLineNumbers,
                theme: highlight_code_theme/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, "".concat(props.topbar ? "mt-1" : "")),
                onClick: ()=>{
                    var _text;
                    navigator.clipboard.writeText((_text = props.text) !== null && _text !== void 0 ? _text : "");
                    setCopied(true);
                    setTimeout(()=>setCopied(false), 1000);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: document_duplicate,
                    alt: "Copy"
                })
            }),
            copied && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, (Docs_module_default()).active, "".concat(props.topbar ? "mt-1" : "")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: checkmark_circle,
                    alt: "Text Copied"
                })
            })
        ]
    });
};


/***/ }),

/***/ 29204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46466);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const PrimaryButton = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        ...props,
        onClick: (e)=>{
            var ref;
            if (window.dataLayer && ((ref = props.href) === null || ref === void 0 ? void 0 : ref.includes("app.highlight.io/?sign_up=1"))) {
                e.preventDefault();
                if (props.onClick) {
                    props.onClick(e);
                }
                window.gtag("event", "conversion", {
                    send_to: "AW-10833687189/_C5MCLfmoY0YEJXl860o",
                    event_callback: function() {
                        if (props.href) {
                            window.location = props.href;
                        }
                    }
                });
                return false;
            } else {
                if (props.onClick) {
                    props.onClick(e);
                }
            }
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(props.className, (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().genericButton), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().primaryButton)),
        children: children
    });
};


/***/ }),

/***/ 10198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const highlightCodeTheme = {
    lineNumberColor: "#6272a4",
    lineNumberBgColor: "#282a36",
    backgroundColor: "#282a36",
    textColor: "#FFFFFF",
    substringColor: "#36E79B",
    keywordColor: "#FF5377",
    attributeColor: "#FF9457",
    selectorTagColor: "#8be9fd",
    docTagColor: "#36E79B",
    nameColor: "#66d9ef",
    builtInColor: "#FF9457",
    literalColor: "#FF5377",
    bulletColor: "#8BE9FD",
    codeColor: "#FF9457",
    additionColor: "#36E79B",
    regexpColor: "#36E79B",
    symbolColor: "#36E79B",
    variableColor: "#FFFFFF",
    templateVariableColor: "#FF5377",
    linkColor: "#00bcd4",
    selectorAttributeColor: "#FF5377",
    selectorPseudoColor: "#FF5377",
    typeColor: "#8BE9FD",
    stringColor: "#36E79B",
    selectorIdColor: "#FF9457",
    selectorClassColor: "#FF9457",
    quoteColor: "#E9F284",
    templateTagColor: "#FF5377",
    deletionColor: "#FF5377",
    titleColor: "#ff5580",
    sectionColor: "#FFFFFF",
    commentColor: "#6272A4",
    metaKeywordColor: "#FF9457",
    metaColor: "#FF9457",
    functionColor: "#FF9457",
    numberColor: "#bd93f9"
};
/* harmony default export */ __webpack_exports__["Z"] = (highlightCodeTheme);


/***/ }),

/***/ 44688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ HighlightLogo; },
  "s": function() { return /* binding */ HighlightLogoWhite; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-dark.svg
/* harmony default export */ var logo_and_text_on_dark = ({"src":"/_next/static/media/logo-and-text-on-dark.86efd8f2.svg","height":33,"width":167});
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-purple.svg
/* harmony default export */ var logo_and_text_on_purple = ({"src":"/_next/static/media/logo-and-text-on-purple.0665af5c.svg","height":33,"width":167});
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.module.scss
var HighlightLogo_module = __webpack_require__(44579);
var HighlightLogo_module_default = /*#__PURE__*/__webpack_require__.n(HighlightLogo_module);
;// CONCATENATED MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx





const HighlightLogo = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_dark,
            alt: ""
        })
    });
};
const HighlightLogoWhite = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_purple,
            alt: ""
        })
    });
};


/***/ }),

/***/ 20026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46717);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Typography = (param)=>{
    let { children , emphasis =false , onDark =false , className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copyHeader)]: props.type === "copyHeader",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy1)]: props.type === "copy1",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy2)]: props.type === "copy2",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy3)]: props.type === "copy3",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy4)]: props.type === "copy4",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().outline)]: props.type === "outline",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().emphasis)]: emphasis,
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().onDark)]: onDark
        }),
        children: children
    });
};


/***/ }),

/***/ 18197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _doc_; },
  "getDocsPaths": function() { return /* binding */ getDocsPaths; },
  "parseMarkdown": function() { return /* binding */ parseMarkdown; },
  "readMarkdown": function() { return /* binding */ readMarkdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: fs (ignored)
var fs_ignored_ = __webpack_require__(61111);
// EXTERNAL MODULE: ./node_modules/js-yaml/dist/js-yaml.mjs
var js_yaml = __webpack_require__(1272);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/index.js + 3 modules
var next_mdx_remote = __webpack_require__(43305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-collapse/lib/index.js
var lib = __webpack_require__(56180);
// EXTERNAL MODULE: ./components/Docs/Docs.module.scss
var Docs_module = __webpack_require__(75698);
var Docs_module_default = /*#__PURE__*/__webpack_require__.n(Docs_module);
;// CONCATENATED MODULE: ./public/images/ChevronDownIcon.tsx


function SvgChevronDownIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "4 4 16 16",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M15.25 10.75L12 14.25l-3.25-3.5"
        })
    });
}
/* harmony default export */ var ChevronDownIcon = (SvgChevronDownIcon);

;// CONCATENATED MODULE: ./public/images/MinusIcon.tsx


function SvgMinusIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            className: props.className,
            d: "M16 12H8",
            stroke: "#DFDFDF",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
/* harmony default export */ var MinusIcon = (SvgMinusIcon);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(1864);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/gray-matter/index.js
var gray_matter = __webpack_require__(9675);
var gray_matter_default = /*#__PURE__*/__webpack_require__.n(gray_matter);
// EXTERNAL MODULE: ./node_modules/markdown-to-jsx/dist/index.modern.js
var index_modern = __webpack_require__(86243);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./components/common/Head/Meta.tsx
var Meta = __webpack_require__(50745);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 3 modules
var Navbar = __webpack_require__(77911);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography_Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(73985);
;// CONCATENATED MODULE: ./components/Docs/Callout/Callout.tsx




const Callout_Callout = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Docs_module_default()).callout,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).calloutIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Docs_module_default()).icon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaInfoCircle */.DAO, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).calloutContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                    className: (Docs_module_default()).contentRender,
                    children: props.content
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/images/thumbnail.svg
/* harmony default export */ var thumbnail = ({"src":"/_next/static/media/thumbnail.d0cab49a.svg","height":581,"width":1199});
;// CONCATENATED MODULE: ./public/images/jay.png
/* harmony default export */ var jay = ({"src":"/_next/static/media/jay.5c41efc7.png","height":56,"width":56,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEVMaXHb0fCvfGHKm4bw7vddVV18aXf///7m4u7////l3fihoKH///++wMM5MEzb0ezYz8vps5e5mq3Dhmrw7PfXraa2ucPZ3OHIwcCdhYnUyOvv6PttSzmTd2mddF5yY52sl+DmqIu1o965jHFkYm/Ar+eAcIxPLh6uns9648HeAAAAHnRSTlMA9/7+l/v7Kb8W+PhA3Pfs7f7+/qb+8af0/vbJ/vkMfjn5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAASUlEQVQImQXBCQKAEBQFwBfxifZ9I1rvf8JmAKuMUQTYTG7vkxHWbw9M3B2SyDmbY4Ll6EPbHCWUl7UrfAoartOJXAM0TlWq8QOWGAQ5VVeiKwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/playButton.svg
/* harmony default export */ var playButton = ({"src":"/_next/static/media/playButton.05231f7b.svg","height":112,"width":112});
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
;// CONCATENATED MODULE: ./components/Home/HeroVideo/HeroVideo.tsx










// When someone scrolls with the video open we close the video after scrolling
// this many pixels.
const SCROLL_THRESHOLD = 50;
const HeroVideo_HeroVideo = ()=>{
    const [hideVideo, setHideVideo] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const showVideo = ()=>{
        setScrollPosition(window.scrollY);
        setHideVideo(false);
    };
    const scrollHandler = useCallback(()=>{
        if (hideVideo) {
            return;
        }
        if (Math.abs(window.scrollY - scrollPosition) > SCROLL_THRESHOLD) {
            setHideVideo(true);
        }
    }, [
        hideVideo,
        scrollPosition
    ]);
    useEffect(()=>{
        window.removeEventListener("scroll", scrollHandler);
        window.addEventListener("scroll", scrollHandler);
        return ()=>window.removeEventListener("scroll", scrollHandler);
    }, [
        scrollHandler
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.anchorImage, styles.heroImage, styles.imageInner),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles.videoModal, {
                    [styles.hideVideo]: hideVideo
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.modalBg,
                        onClick: ()=>setHideVideo(true),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.modalClose,
                            children: /*#__PURE__*/ _jsx(FaTimes, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: !hideVideo && /*#__PURE__*/ _jsx("video", {
                            controls: true,
                            autoPlay: true,
                            children: /*#__PURE__*/ _jsx("source", {
                                src: "/images/herovideo.mp4",
                                type: "video/mp4"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.playButton,
                onClick: showVideo,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.jayImage,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: Jay,
                            alt: "Jay"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.playButtonIcon,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: PlayButton,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.playCard,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                type: "copy1",
                                emphasis: true,
                                children: "Watch Jay demo Highlight"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                type: "copy2",
                                children: "Under 2 minutes"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.thumbnail,
                onClick: showVideo,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: VideoThumbnail,
                    alt: ""
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx + 2 modules
var HighlightCodeBlock_HighlightCodeBlock = __webpack_require__(96736);
;// CONCATENATED MODULE: ./components/Docs/DocsTypographyRenderer/DocsTypographyRenderer.tsx










const getIdFromHTMLHeaderProps = (props)=>{
    return props === null || props === void 0 ? void 0 : props.children.map((child)=>child.props ? child.props.children[0].value : child).join("").replace(/[^a-zA-Z ]/g, "").trim().split(" ").join("-");
};
const getIdFromHeaderProps = (props)=>{
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : ref.children.map((child)=>{
        return child.tagName === "code" ? child === null || child === void 0 ? void 0 : child.children[0].value : child.value;
    }).join("").replace(/[^a-zA-Z ]/g, "").trim().split(" ").join("-");
};
const generateIdString = (str)=>{
    return str.replace(/[^a-zA-Z ]/g, "").trim().split(" ").join("-");
};
const copyHeadingIcon = (index)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (Docs_module_default()).headingCopyIcon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiLink */.Wlb, {})
    }, index);
};
const DocsMarkdownRenderer = (renderType)=>{
    function DocsTypography(param) {
        let { ...props } = param;
        var ref, ref1;
        const router = (0,next_router.useRouter)();
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: renderType === "code" ? props && props.children && props.inline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                className: (Docs_module_default()).inlineCodeBlock,
                children: props.children[0]
            }) : props.className === "language-hint" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Callout_Callout, {
                content: props.children[0]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock_HighlightCodeBlock/* HighlightCodeBlock */.d, {
                language: props.className ? props.className.split("language-").pop() : "js",
                text: props.children[0],
                showLineNumbers: false
            }) : renderType === "a" ? ((ref = props.children) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: props.href,
                legacyBehavior: true,
                children: props.children[0]
            }) : /*#__PURE__*/ (0,react.createElement)(renderType, {
                className: (Docs_module_default()).contentRender,
                ...[
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6"
                ].includes(renderType) ? {
                    id: getIdFromHTMLHeaderProps(props),
                    onClick: ()=>{
                        var ref;
                        (ref = document.querySelector("#".concat(getIdFromHeaderProps(props)))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        const basePath = router.asPath.split("#")[0];
                        const newUrl = "".concat(basePath, "#").concat(getIdFromHTMLHeaderProps(props));
                        window.history.replaceState({
                            ...window.history.state,
                            as: newUrl,
                            url: newUrl
                        }, "", newUrl);
                    }
                } : {}
            }, [
                ...props === null || props === void 0 ? void 0 : props.children.map((c, i)=>{
                    return c.props ? /*#__PURE__*/ (0,react.createElement)("code", {
                        key: i,
                        className: (Docs_module_default()).inlineCodeBlock
                    }, c === null || c === void 0 ? void 0 : c.props.children) : c;
                }),
                copyHeadingIcon((ref2 = props === null || props === void 0 ? void 0 : (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref2 !== void 0 ? ref2 : 0)
            ] || "")
        });
    }
    return DocsTypography;
};
const MethodParameterRenderer = (renderType)=>{
    function DocsTypography(param) {
        let { ...props } = param;
        var ref, ref1;
        const router = useRouter();
        var ref2;
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: renderType === "code" ? props && props.children && props.inline ? /*#__PURE__*/ _jsx("code", {
                className: styles.inlineCodeBlock,
                children: props.children[0]
            }) : /*#__PURE__*/ _jsx(HighlightCodeBlock, {
                language: props.className ? props.className.split("language-").pop() : "js",
                text: props.children[0],
                showLineNumbers: false
            }) : renderType === "a" ? ((ref = props.children) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ _jsx(Link, {
                href: props.href,
                legacyBehavior: true,
                children: props.children[0]
            }) : /*#__PURE__*/ createElement(renderType, {
                className: classNames(styles.contentRender),
                ...[
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6"
                ].includes(renderType) ? {
                    id: getIdFromHTMLHeaderProps(props),
                    onClick: ()=>{
                        var ref;
                        (ref = document.querySelector("#".concat(getIdFromHeaderProps(props)))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        const basePath = router.asPath.split("#")[0];
                        const newUrl = "".concat(basePath, "#").concat(getIdFromHTMLHeaderProps(props));
                        window.history.replaceState({
                            ...window.history.state,
                            as: newUrl,
                            url: newUrl
                        }, "", newUrl);
                    }
                } : {}
            }, [
                ...props === null || props === void 0 ? void 0 : props.children.map((c, i)=>{
                    return c.props ? /*#__PURE__*/ createElement("code", {
                        key: i,
                        className: styles.inlineCodeBlock
                    }, c === null || c === void 0 ? void 0 : c.props.children) : c;
                }),
                copyHeadingIcon((ref2 = props === null || props === void 0 ? void 0 : (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref2 !== void 0 ? ref2 : 0)
            ] || "")
        });
    }
    return DocsTypography;
};
const getDocsTypographyRenderer = (type)=>{
    function DocsTypography(param) {
        let { ...props } = param;
        var ref, ref1, ref2, ref3;
        const router = useRouter();
        var ref4;
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: type === "code" ? props && props.children && props.inline ? /*#__PURE__*/ _jsx("code", {
                className: styles.inlineCodeBlock,
                children: props.children[0]
            }) : props.className === "language-welcomevideo" ? /*#__PURE__*/ _jsx("div", {
                className: styles.customComponent,
                children: /*#__PURE__*/ _jsx(HeroVideo, {})
            }) : props.className === "language-hint" ? /*#__PURE__*/ _jsx(Callout, {
                content: props.children[0]
            }) : /*#__PURE__*/ _jsx(HighlightCodeBlock, {
                language: props.className ? props.className.split("language-").pop() : "js",
                text: props.children[0],
                showLineNumbers: false
            }) : type === "ul" ? /*#__PURE__*/ _jsx("ul", {
                style: {
                    listStyle: "disc outside"
                },
                children: props.children.map((c, i)=>{
                    return c.type === "li" && /*#__PURE__*/ _jsx("li", {
                        className: styles.listItem,
                        children: c.props.children.map((e)=>e)
                    }, i);
                })
            }) : type === "a" ? ((ref = props.children) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ _jsx(Link, {
                href: props.href,
                legacyBehavior: true,
                children: props.children[0]
            }) : /*#__PURE__*/ createElement(type, {
                className: styles.contentRender,
                ...[
                    "h4",
                    "h5",
                    "h6"
                ].includes(type) ? {
                    id: getIdFromHeaderProps(props),
                    onClick: ()=>{
                        var ref;
                        (ref = document.querySelector("#".concat(getIdFromHeaderProps(props)))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        const basePath = router.asPath.split("#")[0];
                        const newUrl = "".concat(basePath, "#").concat(getIdFromHeaderProps(props));
                        window.history.replaceState({
                            ...window.history.state,
                            as: newUrl,
                            url: newUrl
                        }, "", newUrl);
                    }
                } : {}
            }, [
                ...props === null || props === void 0 ? void 0 : (ref1 = props.node) === null || ref1 === void 0 ? void 0 : ref1.children.map((c, i)=>{
                    return c.tagName === "code" ? /*#__PURE__*/ createElement(c.tagName, {
                        key: i,
                        className: styles.inlineCodeBlock
                    }, c === null || c === void 0 ? void 0 : c.children[0].value) : c.value;
                }),
                copyHeadingIcon((ref4 = props === null || props === void 0 ? void 0 : (ref2 = props.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.children) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref4 !== void 0 ? ref4 : 0)
            ] || "")
        });
    }
    return DocsTypography;
};

;// CONCATENATED MODULE: ./components/Docs/DocLayout/DocLayout.tsx





const CLASSNAME_MAP = {
    section: (Docs_module_default()).sdkDocSection,
    left: (Docs_module_default()).sdkLeftColumn,
    right: (Docs_module_default()).sdkRightColumn,
    parameter: (Docs_module_default()).methodParameter,
    innerParameterContainer: (Docs_module_default()).innerParameterContainer,
    innerParameterHeading: (Docs_module_default()).innerParameterHeading
};
const DocSection = (param)=>{
    let { content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
        options: {
            createElement (type, props, children) {
                return /*#__PURE__*/ (0,react.createElement)(type, {
                    ...props,
                    className: CLASSNAME_MAP[props.className]
                }, children);
            },
            overrides: {
                h1: DocsMarkdownRenderer("h4"),
                h2: DocsMarkdownRenderer("h4"),
                h3: DocsMarkdownRenderer("h4"),
                h4: DocsMarkdownRenderer("h4"),
                h5: DocsMarkdownRenderer("h5"),
                code: DocsMarkdownRenderer("code"),
                a: DocsMarkdownRenderer("a")
            }
        },
        children: content
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 2 modules
var listbox = __webpack_require__(79949);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/DocumentIcon.js
var DocumentIcon = __webpack_require__(45581);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/DocumentTextIcon.js
var DocumentTextIcon = __webpack_require__(7803);
;// CONCATENATED MODULE: ./components/Docs/DocSelect/DocSelect.tsx









const DOCS_TYPES = [
    {
        id: 1,
        name: "General Docs",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentIcon/* default */.Z, {}),
        url: "/docs/general/welcome",
        baseUrl: "/docs/general"
    },
    {
        id: 1,
        name: "Getting Started",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/getting-started/overview",
        baseUrl: "/docs/getting-started"
    },
    {
        id: 2,
        name: "Node.js SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/nodejs",
        baseUrl: "/docs/sdk/nodejs"
    },
    {
        id: 3,
        name: "Next.js SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/nextjs",
        baseUrl: "/docs/sdk/nodejs"
    },
    {
        id: 4,
        name: "Cloudflare Worker SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/cloudflare",
        baseUrl: "/docs/sdk/nodejs"
    },
    {
        id: 5,
        name: "Python SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/python",
        baseUrl: "/docs/sdk/python"
    },
    {
        id: 6,
        name: "Golang SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/go",
        baseUrl: "/docs/sdk/go"
    },
    {
        id: 7,
        name: "Client SDK Documentation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentTextIcon/* default */.Z, {}),
        url: "/docs/sdk/client",
        baseUrl: "/docs/sdk/client"
    }
];
const findSelectedDocByArrayPath = (arrayPath)=>{
    const index = DOCS_TYPES.findIndex((doc)=>{
        const arrayPathToMatch = doc.baseUrl.replace("/docs/", "");
        return arrayPath.join("/").startsWith(arrayPathToMatch);
    });
    return index === -1 ? 0 : index;
};
function DocSelect() {
    const router = (0,next_router.useRouter)();
    const [selectedDocs, setSelectedDocs] = (0,react.useState)(DOCS_TYPES[findSelectedDocByArrayPath(Array.isArray(router.query.doc) ? router.query.doc : [])]);
    (0,react.useEffect)(()=>{
        setSelectedDocs(DOCS_TYPES[findSelectedDocByArrayPath(Array.isArray(router.query.doc) ? router.query.doc : [])]);
    }, [
        router.query.doc
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox */.R, {
        value: selectedDocs,
        onChange: setSelectedDocs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                className: (Docs_module_default()).docSelect,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Docs_module_default()).docSelectText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Docs_module_default()).tocIcon,
                                children: selectedDocs.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                type: "copy3",
                                emphasis: true,
                                children: selectedDocs.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon, {
                        className: classnames_default()((Docs_module_default()).tocIcon, (Docs_module_default()).chevronDown)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                className: (Docs_module_default()).docSelectList,
                children: DOCS_TYPES.map((doc)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                        value: doc,
                        className: classnames_default()((Docs_module_default()).tocRow),
                        onClick: ()=>{
                            setSelectedDocs(doc);
                            router.push(doc.url);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Docs_module_default()).tocChild,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Docs_module_default()).tocIcon,
                                    children: doc.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                    type: "copy3",
                                    children: doc.name
                                })
                            ]
                        })
                    }, doc.id))
            })
        ]
    });
}
/* harmony default export */ var DocSelect_DocSelect = (DocSelect);

// EXTERNAL MODULE: ./components/MediaQuery/MediaQuery.tsx
var MediaQuery = __webpack_require__(70358);
;// CONCATENATED MODULE: ./pages/api/docs/github.ts
/* provided dependency */ var process = __webpack_require__(34155);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];


// ignored files from docs
const IGNORED_DOCS_PATHS = new Set([
    ".git",
    ".github",
    ".gitignore",
    ".husky",
    ".vscode",
    ".prettierrc",
    "node_modules",
    "package.json",
    "yarn.lock",
    "CHANGELOG.md",
    "CODE_OF_CONDUCT.md",
    "CONTRIBUTING.md",
    "LICENSE",
    "README.md",
    "SECURITY.md"
]);
const token = process.env.GITHUB_TOKEN;
const githubHeaders = {
    accept: "application/vnd.github+json",
    authorization: "Bearer ".concat(token)
};
const removeOrderingPrefix = (path)=>{
    const arrayPath = path.split("/");
    const cleanPath = arrayPath.map((p)=>{
        const prefixLocation = p.indexOf("_");
        return prefixLocation === -1 ? p : p.slice(prefixLocation + 1);
    });
    return cleanPath.join("/");
};
const processDocPath = function(base, fileString) {
    const simple_path = path_browserify_default().join(base, fileString);
    let pp;
    if (fileString.includes("index.md")) {
        // index.md contains the title of a subheading, which can't have content. get rid of "index.md" at the end
        pp = simple_path.split("/").slice(0, -1).join("/");
    } else {
        // strip out any notion of ".md"
        pp = simple_path.replace(".md", "");
        const pp_array = pp.split("/");
    }
    return removeOrderingPrefix(pp);
};
const getGithubDocsPaths = async function() {
    let path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "docs-content/";
    const url = "https://api.github.com/repos/highlight/highlight.io/contents/".concat(path);
    const response = await fetch(url, {
        headers: githubHeaders
    });
    const json = await response.json();
    const childPromises = [];
    let docs = new Map();
    if (!(json === null || json === void 0 ? void 0 : json.length)) return docs;
    for (const path1 of json){
        if (IGNORED_DOCS_PATHS.has(path1.path)) {
            continue;
        }
        if (path1.type === "dir") {
            childPromises.push(getGithubDocsPaths(path1.path));
        } else if (path1.type === "file") {
            childPromises.push((async ()=>{
                const slug = processDocPath("", path1.path);
                const file = await fetch(path1.download_url, {
                    headers: {
                        ...githubHeaders,
                        accept: ""
                    }
                });
                const text = await file.text();
                const sections = text.split("---");
                docs.set(slug, yaml.load(sections[1], {
                    schema: yaml.JSON_SCHEMA
                }));
            })());
        }
    }
    for (const childDocs of (await Promise.all(childPromises))){
        if (childDocs) {
            for (const [path2, doc] of childDocs.entries()){
                docs.set(path2, doc);
            }
        }
    }
    return docs;
};
const getGithubDoc = async (slug)=>{
    const response = await fetch("https://api.github.com/repos/highlight/highlight.io/contents/docs-content/".concat(slug, ".md"), {
        headers: githubHeaders
    });
    if (response.ok) {
        const json = await response.json();
        if (json.type === "file") {
            const text = new Buffer(json.content, json.encoding).toString("ascii");
            const sections = text.split("---");
            return {
                meta: yaml.load(sections[1], {
                    schema: yaml.JSON_SCHEMA
                }),
                content: sections[2]
            };
        } else {
            throw Error("slug ".concat(slug, " is a directory; expected a file"));
        }
    } else if (!slug.endsWith("/index")) {
        return getGithubDoc("".concat(slug, "/index"));
    } else {
        console.error("error fetching from the github api", response);
        return null;
    }
};

;// CONCATENATED MODULE: ./pages/docs/[[...doc]].tsx
/* provided dependency */ var _doc_process = __webpack_require__(34155);



























const DOCS_CONTENT_PATH = path_browserify_default().join(_doc_process.cwd(), "docs-content");
const DOCS_GITUB_LINK = "https://github.com/highlight/highlight.io/blob/main/docs-content/";
const useHeadingsData = (headingTag)=>{
    const router = (0,next_router.useRouter)();
    const [nestedHeadings, setNestedHeadings] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const headingElements = Array.from(document.querySelectorAll(headingTag));
        setNestedHeadings(headingElements);
    }, [
        headingTag,
        router.query
    ]);
    return {
        nestedHeadings
    };
};
// Checks which header is currently in view, and highlights the table of content item on the right.
const useIntersectionObserver = (setActiveId)=>{
    const router = (0,next_router.useRouter)();
    const headingElementsRef = (0,react.useRef)({});
    (0,react.useEffect)(()=>{
        const callback = (headings)=>{
            headingElementsRef.current = {};
            headingElementsRef.current = headings.reduce((map, headingElement)=>{
                map[headingElement.target.id] = headingElement;
                return map;
            }, headingElementsRef.current);
            const visibleHeadings = [];
            Object.keys(headingElementsRef.current).forEach((key)=>{
                const headingElement = headingElementsRef.current[key];
                if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
            });
            if (visibleHeadings.length >= 1) {
                setActiveId(visibleHeadings[0].target.id);
            }
        };
        const observer = new IntersectionObserver(callback, {
            rootMargin: "0px 0px -40% 0px"
        });
        const headingElements = Array.from(document.querySelectorAll("h4, h5"));
        headingElements.forEach((element)=>observer.observe(element));
        return ()=>observer.disconnect();
    }, [
        setActiveId,
        router.query
    ]);
};
const sortByFilePrefix = (a, b)=>{
    const firstStringSplit = a.split("_");
    const secondStringSplit = b.split("_");
    const firstPrefix = Number(firstStringSplit[0]);
    const secondPrefix = Number(secondStringSplit[0]);
    if (firstPrefix && secondPrefix && firstPrefix != secondPrefix) {
        return firstPrefix - secondPrefix;
    } else if (firstPrefix && !secondPrefix) {
        return -1;
    } else if (!firstPrefix && secondPrefix) {
        return 1;
    }
    const firstFileString = firstStringSplit[firstStringSplit.length - 1];
    const secondFileString = secondStringSplit[secondStringSplit.length - 1];
    if (firstFileString > secondFileString) {
        return 1;
    }
    if (firstFileString < secondFileString) {
        return -1;
    }
    if (firstFileString === secondFileString) {
        return 0;
    }
};
const isValidDirectory = (files)=>{
    return files.find((filename)=>filename.includes("index.md")) != null;
};
var __N_SSG = true;
// we need to explicitly pass in 'fs_api' because webpack isn't smart enough to
// know that this is only being called in server-side functions.
const getDocsPaths = async (fs_api, base)=>{
    // each docpath needs to have some hierarchy (so we know if its nested, etc..)
    // each path can either be:
    // - parent w/o content
    // - parent w/ content
    // if (!base) {
    //   base = 'general-docs';
    // }
    base = base !== null && base !== void 0 ? base : "";
    const full_path = path_browserify_default().join(DOCS_CONTENT_PATH, base);
    const read = await fs_api.readdir(full_path);
    if (!isValidDirectory(read)) {
        throw new Error("".concat(full_path, " does not contain an index.md file. An index.md file is required for all documentation directories. "));
    }
    read.sort(sortByFilePrefix);
    let paths = [];
    for(var i = 0; i < read.length; i++){
        const file_string = read[i];
        if (IGNORED_DOCS_PATHS.has(file_string)) {
            continue;
        }
        let total_path = path_browserify_default().join(full_path, file_string);
        const file_path = await fs_api.stat(total_path);
        if (file_path.isDirectory()) {
            paths = paths.concat(await getDocsPaths(fs_api, path_browserify_default().join(base, file_string)));
        } else {
            const pp = processDocPath(base, file_string);
            const { data , links , content  } = await readMarkdown(fs_ignored_.promises, path_browserify_default().join(total_path || ""));
            const hasRequiredMetadata = [
                "title"
            ].every((item)=>data.hasOwnProperty(item));
            if (!hasRequiredMetadata) {
                throw new Error("".concat(total_path, ' does not contain all required metadata fields. Fields "title" are required. '));
            }
            paths.push({
                simple_path: pp,
                array_path: pp.split("/"),
                embedded_links: Array.from(links),
                total_path,
                isSdkDoc: pp.startsWith("sdk/"),
                rel_path: total_path.replace(DOCS_CONTENT_PATH, ""),
                indexPath: file_string.includes("index.md"),
                metadata: data,
                content: content
            });
        }
    }
    return paths;
};
const readMarkdown = async (fs_api, filePath)=>{
    const fileContents = await fs_api.readFile(path_browserify_default().join(filePath));
    return parseMarkdown(fileContents);
};
const parseMarkdown = (fileContents)=>{
    const { content , data  } = gray_matter_default()(fileContents, {
        delimiters: [
            "---",
            "---"
        ],
        engines: {
            yaml: (s)=>js_yaml/* default.load */.ZP.load(s, {
                    schema: js_yaml/* default.JSON_SCHEMA */.ZP.JSON_SCHEMA
                })
        }
    });
    const regex = /(.)\[(.*?)\]\((.*?)\)/g;
    const links = new Set([
        ...content.matchAll(regex)
    ].filter((m)=>m[1] !== "!").map((m)=>{
        return m[3];
    }));
    return {
        content,
        data,
        links
    };
};
const SdkTableOfContents = ()=>{
    const { nestedHeadings  } = useHeadingsData("h4");
    const router = (0,next_router.useRouter)();
    const [activeId, setActiveId] = (0,react.useState)();
    useIntersectionObserver(setActiveId);
    (0,react.useEffect)(()=>{
        const selectedId = router.asPath.split("#");
        if (selectedId.length > 1) {
            var ref;
            (ref = document.querySelector("#".concat(selectedId[1]))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: nestedHeadings.map((heading, i)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                href: "#".concat(heading.id),
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (Docs_module_default()).tocRow,
                    onClick: (e)=>{
                        var ref;
                        e.preventDefault();
                        (ref = document.querySelector("#".concat(heading.id))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        const basePath = router.asPath.split("#")[0];
                        const newUrl = "".concat(basePath, "#").concat(heading.id);
                        window.history.replaceState({
                            ...window.history.state,
                            as: newUrl,
                            url: newUrl
                        }, "", newUrl);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon, {
                            className: classnames_default()((Docs_module_default()).tocIcon, (Docs_module_default()).tocChild, {
                                [(Docs_module_default()).tocItemCurrent]: heading.id === activeId
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                            type: "copy3",
                            className: classnames_default()((Docs_module_default()).tocItem, (Docs_module_default()).tocChild, {
                                [(Docs_module_default()).tocItemCurrent]: heading.id === activeId
                            }),
                            children: heading.innerText || "nope"
                        })
                    ]
                })
            }, i);
        })
    });
};
const PageRightBar = (param)=>{
    let { relativePath  } = param;
    const { nestedHeadings  } = useHeadingsData("h5");
    const router = (0,next_router.useRouter)();
    const [activeId, setActiveId] = (0,react.useState)();
    useIntersectionObserver(setActiveId);
    (0,react.useEffect)(()=>{
        const selectedId = router.asPath.split("#");
        if (selectedId.length > 1) {
            var ref;
            (ref = document.querySelector("#".concat(selectedId[1]))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Docs_module_default()).rightBarWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Docs_module_default()).resourcesSideBar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: (Docs_module_default()).socialItem,
                        href: "https://discord.gg/yxaXEAqgwN",
                        target: "_blank",
                        style: {
                            borderBottom: "1px solid #30294E"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaDiscord */.j2d, {
                                style: {
                                    height: 20,
                                    width: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                type: "copy3",
                                children: "Community / Support"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: (Docs_module_default()).socialItem,
                        href: "".concat(DOCS_GITUB_LINK).concat(relativePath),
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                style: {
                                    height: 20,
                                    width: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                type: "copy3",
                                children: "Suggest Edits?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        style: {
                            borderTop: "1px solid #30294E"
                        },
                        className: (Docs_module_default()).socialItem,
                        href: "https://twitter.com/highlightio",
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                style: {
                                    height: 20,
                                    width: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                type: "copy3",
                                children: "Follow us!"
                            })
                        ]
                    })
                ]
            }),
            nestedHeadings.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).pageContentTable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Docs_module_default()).pageContentList,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: nestedHeadings.map((heading)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: heading.id === activeId ? (Docs_module_default()).active : "",
                                style: {
                                    padding: "2px 4px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#".concat(heading.id),
                                    onClick: (e)=>{
                                        var ref;
                                        e.preventDefault();
                                        (ref = document.querySelector("#".concat(heading.id))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                                            behavior: "smooth"
                                        });
                                        const basePath = router.asPath.split("#")[0];
                                        const newUrl = "".concat(basePath, "#").concat(heading.id);
                                        window.history.replaceState({
                                            ...window.history.state,
                                            as: newUrl,
                                            url: newUrl
                                        }, "", newUrl);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: heading.innerText
                                    })
                                })
                            }, heading.id);
                        })
                    })
                })
            })
        ]
    });
};
const TableOfContents = (param)=>{
    let { toc , docPaths , openParent , openTopLevel =false  } = param;
    var ref, ref1;
    const hasChildren = !!(toc === null || toc === void 0 ? void 0 : toc.children.length);
    const [isCurrentPage, setIsCurrentPage] = (0,react.useState)(false);
    const isTopLevel = toc.tocSlug === ((ref = docPaths[toc.docPathId || 0]) === null || ref === void 0 ? void 0 : ref.array_path[0]);
    const [open, setOpen] = (0,react.useState)(isTopLevel || openTopLevel);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const currentPage = path_browserify_default().join("/docs", ((ref = docPaths[toc.docPathId || 0]) === null || ref === void 0 ? void 0 : ref.simple_path) || "");
        setIsCurrentPage(currentPage === window.location.pathname);
        const isParentOfCurrentPage = window.location.pathname.includes((ref1 = docPaths[toc.docPathId || 0]) === null || ref1 === void 0 ? void 0 : ref1.simple_path);
        setOpen((prevOpenState)=>prevOpenState || isParentOfCurrentPage);
    }, [
        docPaths,
        toc.docPathId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-full",
        children: [
            hasChildren ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Docs_module_default()).tocRow,
                onClick: ()=>setOpen((o)=>!o),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon, {
                        className: classnames_default()((Docs_module_default()).tocIcon, {
                            [(Docs_module_default()).tocItemChevronClosed]: hasChildren && !open,
                            [(Docs_module_default()).tocItemOpen]: hasChildren && open,
                            [(Docs_module_default()).tocItemCurrent]: !hasChildren && open && isCurrentPage,
                            [(Docs_module_default()).tocChild]: !isTopLevel
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                        type: "copy3",
                        emphasis: isTopLevel,
                        className: classnames_default()((Docs_module_default()).tocItem, {
                            [(Docs_module_default()).tocItemOpen]: hasChildren && open,
                            [(Docs_module_default()).tocItemCurrent]: (!hasChildren || open) && isCurrentPage,
                            [(Docs_module_default()).tocChild]: !isTopLevel
                        }),
                        children: (toc === null || toc === void 0 ? void 0 : toc.tocHeading) || "nope"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: path_browserify_default().join("/docs", ((ref1 = docPaths[toc.docPathId || 0]) === null || ref1 === void 0 ? void 0 : ref1.simple_path) || ""),
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (Docs_module_default()).tocRow,
                    onClick: ()=>{
                        setOpen((o)=>!o);
                        if (window.scrollY >= 124) {
                            sessionStorage.setItem("scrollPosition", "124");
                        } else {
                            sessionStorage.setItem("scrollPosition", "0");
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon, {
                            className: classnames_default()((Docs_module_default()).tocIcon, {
                                [(Docs_module_default()).tocItemOpen]: hasChildren,
                                [(Docs_module_default()).tocItemCurrent]: !hasChildren && isCurrentPage,
                                [(Docs_module_default()).tocChild]: !isTopLevel
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                            type: "copy3",
                            emphasis: isTopLevel,
                            className: classnames_default()((Docs_module_default()).tocItem, {
                                [(Docs_module_default()).tocItemOpen]: hasChildren && open,
                                [(Docs_module_default()).tocItemCurrent]: (!hasChildren || open) && isCurrentPage,
                                [(Docs_module_default()).tocChild]: !isTopLevel
                            }),
                            children: (toc === null || toc === void 0 ? void 0 : toc.tocHeading) || "nope"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Collapse, {
                isOpened: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Docs_module_default()).tocChildren,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Docs_module_default()).tocChildrenLineWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Docs_module_default()).tocChildrenLine
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Docs_module_default()).tocChildrenContent,
                            children: toc === null || toc === void 0 ? void 0 : toc.children.map((t)=>// TODO(jaykhatri) - this 'docPaths' concept has to be stateful 🤔.
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                    openParent: open && !isTopLevel,
                                    docPaths: docPaths,
                                    toc: t
                                }, t.docPathId))
                        })
                    ]
                })
            })
        ]
    });
};
const getBreadcrumbs = (metadata, docOptions, docIndex)=>{
    const trail = [
        {
            title: "Docs",
            path: "/docs",
            hasContent: true
        }
    ];
    if (metadata && docOptions) {
        // const currentDocIndex = docOptions?.findIndex(
        //   (d) => d?.metadata?.slug === metadata?.slug
        // );
        const currentDoc = docOptions[docIndex];
        const pathToSearch = [];
        currentDoc.array_path.forEach((section)=>{
            var ref;
            pathToSearch.push(section);
            const simplePath = pathToSearch.join("/");
            const nextBreadcrumb = docOptions.find((d)=>{
                return (d === null || d === void 0 ? void 0 : d.simple_path) === simplePath;
            });
            trail.push({
                title: nextBreadcrumb === null || nextBreadcrumb === void 0 ? void 0 : (ref = nextBreadcrumb.metadata) === null || ref === void 0 ? void 0 : ref.title,
                path: "/docs/".concat(nextBreadcrumb === null || nextBreadcrumb === void 0 ? void 0 : nextBreadcrumb.simple_path),
                hasContent: (nextBreadcrumb === null || nextBreadcrumb === void 0 ? void 0 : nextBreadcrumb.content) != ""
            });
        });
    }
    return trail;
};
const DocPage = (param)=>{
    let { markdownText , markdownTextOG , relPath , slug , toc , isSdkDoc , docIndex , redirect , docOptions , metadata  } = param;
    var ref, ref1, ref2, ref3;
    const blogBody = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    const [open, setOpen] = (0,react.useState)(false);
    const isQuickstart = metadata && "quickstart" in metadata;
    const description = (markdownTextOG || "").replaceAll(/[`[(]+.+[`\])]+/gi, "").replaceAll(/#+/gi, "").split("\n").join(" ");
    (0,react.useEffect)(()=>{
        if (redirect != null) {
            router.push(redirect);
        }
    }, [
        redirect,
        router
    ]);
    (0,react.useEffect)(()=>{
        const storedScrollPosition = sessionStorage.getItem("scrollPosition");
        if (storedScrollPosition) {
            window.scrollTo(0, parseInt(storedScrollPosition));
        }
    }, [
        router
    ]);
    const currentToc = toc === null || toc === void 0 ? void 0 : toc.children.find((c)=>{
        return c.tocSlug === (relPath === null || relPath === void 0 ? void 0 : relPath.split("/").filter((r)=>r)[0]);
    });
    const is400 = (0,MediaQuery/* useMediaQuery */.a)(400);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
                title: (metadata === null || metadata === void 0 ? void 0 : (ref = metadata.title) === null || ref === void 0 ? void 0 : ref.length) ? (metadata === null || metadata === void 0 ? void 0 : metadata.title) === "Welcome to Highlight" ? "Documentation" : metadata === null || metadata === void 0 ? void 0 : metadata.title : "",
                description: description,
                absoluteImageUrl: "https://".concat("highlight-landing-232fv6uy5-highlight-run.vercel.app", "/api/og/doc").concat(relPath === null || relPath === void 0 ? void 0 : relPath.replace(".md", "")),
                canonical: "/docs/".concat(slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                title: "Docs",
                hideBanner: true,
                isDocsPage: true,
                fixed: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                ref: blogBody,
                className: (Docs_module_default()).mainWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Docs_module_default()).leftSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Docs_module_default()).leftInner,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocSelect_DocSelect, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Docs_module_default()).tocMenuLarge,
                                children: isSdkDoc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SdkTableOfContents, {}) : currentToc === null || currentToc === void 0 ? void 0 : currentToc.children.map((t)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                        openTopLevel: true,
                                        toc: t,
                                        openParent: true,
                                        docPaths: docOptions
                                    }, t.docPathId);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Docs_module_default()).tocRow, (Docs_module_default()).tocMenu),
                                onClick: ()=>setOpen((o)=>!o),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Docs_module_default()).tocMenuLabel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon, {
                                            className: classnames_default()((Docs_module_default()).tocIcon, {
                                                [(Docs_module_default()).tocItemOpen]: open
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                            type: "copy3",
                                            emphasis: true,
                                            className: classnames_default()((Docs_module_default()).tocItem, {
                                                [(Docs_module_default()).tocItemOpen]: open
                                            }),
                                            children: "Menu"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Collapse, {
                                isOpened: open,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Docs_module_default()).tocContents, (Docs_module_default()).tocMenu),
                                    children: isSdkDoc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SdkTableOfContents, {}) : toc === null || toc === void 0 ? void 0 : toc.children.map((t)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                            toc: t,
                                            docPaths: docOptions,
                                            openParent: false,
                                            openTopLevel: false
                                        }, t.docPathId))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Docs_module_default()).contentSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("DocSearch-content", (Docs_module_default()).centerSection, {
                                    [(Docs_module_default()).sdkCenterSection]: isSdkDoc,
                                    [(Docs_module_default()).quickStartCenterSection]: isQuickstart
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Docs_module_default()).breadcrumb,
                                        children: !isSdkDoc && getBreadcrumbs(metadata, docOptions, docIndex).map((breadcrumb, i)=>i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: breadcrumb.path,
                                                legacyBehavior: true,
                                                children: breadcrumb.title
                                            }) : breadcrumb.hasContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    " / ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: breadcrumb.path,
                                                        legacyBehavior: true,
                                                        children: breadcrumb.title
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    " / ",
                                                    breadcrumb.title
                                                ]
                                            }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: classnames_default()((Docs_module_default()).pageTitle, {
                                            [(Docs_module_default()).sdkPageTitle]: isSdkDoc
                                        }),
                                        children: (metadata === null || metadata === void 0 ? void 0 : metadata.heading) ? metadata.heading : (metadata === null || metadata === void 0 ? void 0 : metadata.title) ? metadata.title : ""
                                    }),
                                    isSdkDoc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DocSection, {
                                        content: markdownTextOG || ""
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Docs_module_default()).contentRender,
                                            children: markdownText && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_mdx_remote/* MDXRemote */.R, {
                                                components: {
                                                    QuickStart,
                                                    DocsCard,
                                                    DocsCardGroup,
                                                    h1: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            ...props
                                                        }),
                                                    h2: (props)=>{
                                                        if (props.children && typeof props.children === "string") {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                id: generateIdString(props.children),
                                                                ...props
                                                            });
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                                    },
                                                    h3: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            ...props
                                                        }),
                                                    h4: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            ...props
                                                        }),
                                                    h5: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            ...props
                                                        }),
                                                    code: (props)=>{
                                                        // check if props.children is a string
                                                        if (props.children && props.className === "language-hint") {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Callout_Callout, {
                                                                content: props.children
                                                            });
                                                        } else if (typeof props.children === "string" && (props.children.match(/\n/g) || []).length) {
                                                            var ref;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock_HighlightCodeBlock/* HighlightCodeBlock */.d, {
                                                                language: props.className ? (ref = props.className.split("language-").pop()) !== null && ref !== void 0 ? ref : "js" : "js",
                                                                text: props.children,
                                                                showLineNumbers: false
                                                            });
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                                            className: (Docs_module_default()).inlineCodeBlock,
                                                            children: props.children
                                                        });
                                                    },
                                                    ul: (props)=>{
                                                        var ref;
                                                        // check if the type of props.children is an array.
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: Array.isArray(props.children) && (props === null || props === void 0 ? void 0 : (ref = props.children) === null || ref === void 0 ? void 0 : ref.map((c, i)=>{
                                                                var ref, ref1;
                                                                return c.props && c.props.children && c.props.children.map && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: (Docs_module_default()).listItem,
                                                                    children: c === null || c === void 0 ? void 0 : (ref = c.props) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.map((e)=>e)
                                                                }, i);
                                                            }))
                                                        });
                                                    }
                                                },
                                                ...markdownText
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Docs_module_default()).pageNavigateRow,
                                        children: [
                                            docIndex > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: (ref4 = (ref1 = docOptions[docIndex - 1]) === null || ref1 === void 0 ? void 0 : ref1.simple_path) !== null && ref4 !== void 0 ? ref4 : "",
                                                passHref: true,
                                                className: (Docs_module_default()).pageNavigate,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiChevronLeft */.gbs, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        children: (ref2 = docOptions[docIndex - 1]) === null || ref2 === void 0 ? void 0 : ref2.metadata.title
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                            docIndex < (docOptions === null || docOptions === void 0 ? void 0 : docOptions.length) - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: (ref5 = (ref3 = docOptions[docIndex + 1]) === null || ref3 === void 0 ? void 0 : ref3.simple_path) !== null && ref5 !== void 0 ? ref5 : "",
                                                passHref: true,
                                                className: (Docs_module_default()).pageNavigate,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        children: docOptions[docIndex + 1].metadata.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiChevronRight */.lU2, {})
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                        ]
                                    })
                                ]
                            }),
                            !isSdkDoc && !isQuickstart && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Docs_module_default()).rightSection,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageRightBar, {
                                    title: metadata ? metadata.title : "",
                                    relativePath: relPath ? relPath : ""
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// component with children
const DocsCardGroup = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Docs_module_default()).docsCardGroup,
        children: children
    });
};
const DocsCard = (param)=>{
    let { children , title , path , href  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: href,
        className: (Docs_module_default()).docsCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                type: "copy2",
                emphasis: true,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                type: "copy2",
                children: children
            })
        ]
    });
};
const QuickStart = (content)=>{
    const { content: c  } = content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 40
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                onDark: true,
                type: "copy1",
                children: c.subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    borderTop: "1px solid #EBFF5E",
                    width: 200
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 10
                },
                children: c.entries.map((step, i)=>{
                    if (step.hidden) return null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: 24
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    width: 40,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            width: 32,
                                            minHeight: 32,
                                            backgroundColor: "#30294E",
                                            borderRadius: 100,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            width: 16,
                                            height: "100%",
                                            borderRight: "2px solid #30294E"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    width: "100%",
                                    display: "flex",
                                    gap: 20,
                                    marginBottom: 42
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "50%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 8
                                        },
                                        className: (Docs_module_default()).quickStartSubtext,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* Typography */.Z, {
                                                type: "copy2",
                                                emphasis: true,
                                                children: step.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
                                                options: {
                                                    forceBlock: true,
                                                    overrides: {
                                                        code: (props)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                                                className: (Docs_module_default()).inlineCodeBlock,
                                                                children: props.children
                                                            });
                                                        },
                                                        ul: (props)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: "hellooooo"
                                                            });
                                                        }
                                                    }
                                                },
                                                children: step.content
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            width: "50%"
                                        },
                                        children: step.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock_HighlightCodeBlock/* HighlightCodeBlock */.d, {
                                            style: {
                                                position: "sticky",
                                                top: "80px"
                                            },
                                            language: step.code.language,
                                            text: step.code.text,
                                            showLineNumbers: false
                                        })
                                    })
                                ]
                            })
                        ]
                    }, JSON.stringify(step));
                })
            })
        ]
    });
};
/* harmony default export */ var _doc_ = (DocPage);


/***/ }),

/***/ 75698:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Docs_mainWrapper__FXUeq","docsCard":"Docs_docsCard__otr1Y","docsCardGroup":"Docs_docsCardGroup__01dpF","docsCardPara":"Docs_docsCardPara__p_t5V","leftSection":"Docs_leftSection__obmR_","listItem":"Docs_listItem__yoc5q","active":"Docs_active__1H8j4","emptyContent":"Docs_emptyContent__HZyG5","searchResultCard":"Docs_searchResultCard__HoCml","content":"Docs_content__eXCi0","resultTitle":"Docs_resultTitle__u_Ok4","highlightedText":"Docs_highlightedText__qEoz1","tocIcon":"Docs_tocIcon__jhnhr","tocRow":"Docs_tocRow__uCwZO","tocChild":"Docs_tocChild__DEzRd","tocItem":"Docs_tocItem__zayx3","tocItemChevronClosed":"Docs_tocItemChevronClosed__vvJYn","tocItemOpen":"Docs_tocItemOpen__3TrfE","tocItemCurrent":"Docs_tocItemCurrent__I8muf","tocChildren":"Docs_tocChildren__PoknC","tocChildrenLineWrapper":"Docs_tocChildrenLineWrapper__GbkOD","tocChildrenLine":"Docs_tocChildrenLine__l3kNX","tocChildrenContent":"Docs_tocChildrenContent__yTpCr","pageTitle":"Docs_pageTitle__rtkmX","sdkPageTitle":"Docs_sdkPageTitle__koGyT","quickStartSubtext":"Docs_quickStartSubtext__F6fJJ","contentRender":"Docs_contentRender__xZOXl","sdkRightColumn":"Docs_sdkRightColumn__yipIy","sdkLeftColumn":"Docs_sdkLeftColumn__KZyoS","inlineCodeBlock":"Docs_inlineCodeBlock__i42rv","headingCopyIcon":"Docs_headingCopyIcon__L6gY8","docSelect":"Docs_docSelect__ry3Bu","docSelectText":"Docs_docSelectText__eKCeK","chevronDown":"Docs_chevronDown__d47Bs","docSelectList":"Docs_docSelectList__sZvi9","contentInnerBar":"Docs_contentInnerBar__oVUjo","leftInner":"Docs_leftInner__RF3OK","centerInner":"Docs_centerInner__bL99U","searchContainer":"Docs_searchContainer__0qCYJ","searchDiv":"Docs_searchDiv__u4Smh","spinner":"Docs_spinner__RE0vP","codeBlock":"Docs_codeBlock__GmOTo","codeBlockTopper":"Docs_codeBlockTopper__nWwNU","codeCopyIcon":"Docs_codeCopyIcon__8Tsch","contentSection":"Docs_contentSection__3OQpo","centerSection":"Docs_centerSection__jxxYw","sdkCenterSection":"Docs_sdkCenterSection__WkN9l","quickStartCenterSection":"Docs_quickStartCenterSection__yktxM","rightSection":"Docs_rightSection__SZw9H","headingSection":"Docs_headingSection__x5be1","docLink":"Docs_docLink__taM7v","rightBarWrap":"Docs_rightBarWrap__jakYW","socialItem":"Docs_socialItem__fuzrp","sdkSocialItem":"Docs_sdkSocialItem__5dt4_","resourcesSideBar":"Docs_resourcesSideBar__lgF62","resourcesMobile":"Docs_resourcesMobile__uiihJ","pageContentTable":"Docs_pageContentTable__fTiVM","pageNavigateRow":"Docs_pageNavigateRow__QcMzN","pageNavigate":"Docs_pageNavigate__CdpBF","pageContentTitle":"Docs_pageContentTitle__EhHKD","pageContentIcon":"Docs_pageContentIcon__iQl8C","pageContentList":"Docs_pageContentList__Lzsbr","pageContentBullet":"Docs_pageContentBullet__DjElc","breadcrumb":"Docs_breadcrumb__bU57t","tocMenu":"Docs_tocMenu__l8_Vh","tocMenuLarge":"Docs_tocMenuLarge__eUA0l","customComponent":"Docs_customComponent___gky_","callout":"Docs_callout__TRexG","calloutIcon":"Docs_calloutIcon__6q_MY","icon":"Docs_icon__GZ_cR","calloutContent":"Docs_calloutContent__MYxQS","sdkDocSection":"Docs_sdkDocSection__vCPp1","methodParameter":"Docs_methodParameter__PZHhd","innerParameterContainer":"Docs_innerParameterContainer__U8ZlW","innerParameterHeading":"Docs_innerParameterHeading__NS93a","sdkRender":"Docs_sdkRender__SrVGr","tocMenuLabel":"Docs_tocMenuLabel__DutJo","tocContents":"Docs_tocContents__HV81g"};

/***/ }),

/***/ 46466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"Buttons_genericButton__1FVcd","primaryButton":"Buttons_primaryButton__F0qwS","secondaryButton":"Buttons_secondaryButton__ONMAh","arrow":"Buttons_arrow__FYbFj"};

/***/ }),

/***/ 44579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"HighlightLogo_logoDiv__7LoQB","logoText":"HighlightLogo_logoText__yxbvU","logo":"HighlightLogo_logo__bx_mM"};

/***/ }),

/***/ 36109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__Hki0p","hide":"Navbar_hide__zNudc","header":"Navbar_header__4yLzB","headerPadding":"Navbar_headerPadding__I31dq","headerInner":"Navbar_headerInner__WU6T_","headerBorder":"Navbar_headerBorder__vq_i7","hideNavbar":"Navbar_hideNavbar__aZu63","navContainer":"Navbar_navContainer__Pkz7d","navMenu":"Navbar_navMenu__vSmJQ","mobileMenu":"Navbar_mobileMenu__lUigM","menuList":"Navbar_menuList__bWJqX","menuItem":"Navbar_menuItem__q_j2E","chevronDown":"Navbar_chevronDown__L4333","menuDropdown":"Navbar_menuDropdown__oDsSP","headerButton":"Navbar_headerButton__zJw2r","headerButtonRight":"Navbar_headerButtonRight__s4Uep","popoverButton":"Navbar_popoverButton__WiIZs","popover":"Navbar_popover__VpYiX","popoverPanel":"Navbar_popoverPanel___S3Zu","innerPopoverPanel":"Navbar_innerPopoverPanel__IVRN3","copyOnLight":"Navbar_copyOnLight__hCG9U","copyOnDark":"Navbar_copyOnDark__o_J8Z","white":"Navbar_white__e_2Nx","gridContainer":"Navbar_gridContainer__G_6Aq","innerGridContainer":"Navbar_innerGridContainer__3rIoQ","gridItem":"Navbar_gridItem__OAdnU","signUpButton":"Navbar_signUpButton__p_R_j","headerLeft":"Navbar_headerLeft__pZY9_","headerLeftBlog":"Navbar_headerLeftBlog__mTNOx","headerCenter":"Navbar_headerCenter__flPxm","headerRight":"Navbar_headerRight__IvOsm","socialButtonContainer":"Navbar_socialButtonContainer__5c9GH","socialButtonWrapper":"Navbar_socialButtonWrapper__xU9QK","socialButton":"Navbar_socialButton__UeEDd","socialButtonWrapperLeft":"Navbar_socialButtonWrapperLeft__mYCJz","socialButtonWrapperRight":"Navbar_socialButtonWrapperRight__TlP3q","socialButtonDivider":"Navbar_socialButtonDivider__bzsqw","urlStyle":"Navbar_urlStyle__VOVlz","dropdownItem":"Navbar_dropdownItem__Y_43b","bannerContainer":"Navbar_bannerContainer__NWyOW","callToAction":"Navbar_callToAction__v1q4L","bannerContainerBlog":"Navbar_bannerContainerBlog__a6fvz","navTitle":"Navbar_navTitle__pjZ9_","navPostTitle":"Navbar_navPostTitle__O2TUd","loadingBar":"Navbar_loadingBar__BZ3Iq","fixed":"Navbar_fixed__NYJVb","openHeader":"Navbar_openHeader__pxQwC","mobileHeader":"Navbar_mobileHeader__rk96w","menuButtons":"Navbar_menuButtons__8kzLj","menuItemLarge":"Navbar_menuItemLarge__B4JsK"};

/***/ }),

/***/ 46717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"copyHeader":"Typography_copyHeader__vgPrK","copy1":"Typography_copy1__Cenb_","copy2":"Typography_copy2__ebmOc","copy3":"Typography_copy3__66v_e","copy4":"Typography_copy4__R2A2_","onDark":"Typography_onDark__0klmC","emphasis":"Typography_emphasis__GjrIs","outline":"Typography_outline__J0c64"};

/***/ }),

/***/ 33596:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 61111:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3874,6146,3826,1399,3985,1443,9304,7911,8558,9774,2888,179], function() { return __webpack_exec__(80693); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);